import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import './App.css'; // Make sure this is here!
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Events from './components/Events';
import Gallery from './components/Gallery';
import Results from './components/Results';
import Schedule from './components/Schedule';
import Sponsors from './components/Sponsors';
import Store from './components/Store';
import Footer from './components/Footer';
import AuthModal from './components/AuthModal';
import Success from './components/Success';
import SuccessRace from './components/SuccessRace';
import RaceEntry from './components/RaceEntry';
import Ads from './components/Ads';

function App() {
  const [isAuthOpen, setIsAuthOpen] = useState(false);
  const [session, setSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  // Simple router based on pathname
  const isSuccessPage = window.location.pathname === '/success';
  const isSuccessRacePage = window.location.pathname === '/success-race';

  if (isSuccessRacePage) {
    return (
      <div className="App">
        <Navbar onLoginClick={() => setIsAuthOpen(true)} session={session} />
        <SuccessRace session={session} />
        <AuthModal isOpen={isAuthOpen} onClose={() => setIsAuthOpen(false)} />
        <Footer />
      </div>
    );
  }

  if (isSuccessPage) {
    return (
      <div className="App">
        <Navbar onLoginClick={() => setIsAuthOpen(true)} session={session} />
        <Success />
        <AuthModal 
          isOpen={isAuthOpen} 
          onClose={() => setIsAuthOpen(false)} 
        />
        <Footer />
      </div>
    );
  }

  return (
    <div className="App">
      <Navbar onLoginClick={() => setIsAuthOpen(true)} session={session} />
      <Hero />

      <main className="container">

        <RaceEntry session={session} />

        <section id="events" className="card"> 
          <Events />
        </section>

        <section id="ads" className="card" style={{ padding: 0, overflow: 'hidden' }}>
          <Ads />
        </section>

        <section id="results" className="card">
          <Results session={session} />
        </section>

        <section id="gallery" className="card">
          <Gallery session={session} />
        </section>

        <section id="schedule" className="card">
          <Schedule />
        </section>
        
        <Store />

        <section id="sponsors" className="card">
          <Sponsors />
        </section>

      </main>

      <AuthModal 
        isOpen={isAuthOpen} 
        onClose={() => setIsAuthOpen(false)} 
      />

      <Footer />
    </div>
  );
}

export default App;
